import { Routes } from '@angular/router';
import { AdminLayoutComponent } from '@app/pages/admin/layout/admin-layout/admin-layout.component';
import { authGuard } from '@app/guards/auth/auth.guard';
import { roleGuard } from '@app/guards/role/role.guard';
import { sessionGuard } from '@app/guards/session/session.guard';
import { MainLayoutComponent } from '@app/pages/public/layout/main-layout/main-layout.component';
import { publicGuard } from '@app/pages/public/guards/public.guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [publicGuard, sessionGuard],
    component: MainLayoutComponent,
    loadChildren: () => import('@app/pages/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [authGuard, sessionGuard, roleGuard],
    data: {
      roles: ['super_admin', 'admin'],
    },
    loadChildren: () => import('@app/pages/admin/admin.module').then((m) => m.AdminModule),
  },
];
